import { FC, useMemo } from 'react';
import { Vacant } from 'common/components/icons/Vacant';
import { InterimSolution } from 'common/components/icons/InterimSolution';
import { IncludedInRent } from 'common/components/icons/IncludedInRent';
import { PremiseTag } from '../Premise';

export const tagIconSourceMap = {
  [PremiseTag.Vacant]: Vacant,
  [PremiseTag.IncludedInRent]: IncludedInRent,
  [PremiseTag.InterimSolution]: InterimSolution,
};

export const PremiseTagIcon: FC<{ tag: PremiseTag }> = ({ tag }) => {
  const Component = useMemo(() => tagIconSourceMap[tag], [tag]);
  return <Component tag={tag} />;
};
